import styled from '@emotion/styled'

export const ModalBody = styled('div')`
  color: rgba(102, 101, 101, 1);
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  padding: 1.5rem 2.5rem;

  @media (max-width: 600px) {
    padding: 1rem 1.25rem 1.5rem;
    font-size: 13px;
  }
`
